export default __webpack_public_path__ + "web/images/products/streamalertsfull_white.svg";